<template>
  <tr class="ce-formulationIngredient">
    <td>
      <template v-if="ingredient.pigment">
        <a
          target="_blank"
          :class="{ disabled: ingredient.pigment.isDeleted }"
          :href="`${links.productsPage}${ingredient.pigment.id}`">
          {{ title }}
        </a>
        <div
          v-if="!ingredient.pigment.isAvailable"
          class="ce-formulationIngredient-notAvailableHint">
          <fa-icon icon="exclamation-triangle" />
          {{ $t('formulationRepository.detailPage.ingredients.notAvailableHint') }}
        </div>
      </template>
      <template v-else>
        {{ title }}

        <div
          v-if="ingredient.isCompetitorProduct && isInternal"
          class="ms-4">
          {{ $t('formulationRepository.detailPage.ingredients.competitorProduct') }}
        </div>
      </template>
    </td>
    <td>
      {{ ingredient.percentage }}
    </td>
  </tr>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    ingredient: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['formulation']),
    ...mapState('generic', ['links']),
    ...mapGetters('user', ['isInternal']),
    competitorProducts() {
      return this.formulation.ingredients.filter((i) => i.isCompetitorProduct);
    },
    title() {
      if (this.ingredient.isCompetitorProduct && !this.isInternal) {
        let title = this.$t('formulationRepository.detailPage.ingredients.competitorProduct');

        if (this.competitorProducts.length > 1) {
          const index = this.competitorProducts.findIndex((i) => i.id === this.ingredient.id);

          // @see https://www.tutorialspoint.com/indexing-numbers-to-alphabets-in-javascript
          title = `${title} ${String.fromCharCode('A'.charCodeAt(0) + index)}`;
        }

        return title;
      }

      return this.ingredient.title;
    }
  },
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-formulationIngredient {
  .ce-formulationIngredient-notAvailableHint {
    display: flex;
    align-items: center;
    .ms(-1);

    svg {
      margin-right: @space-1;
    }
  }
}
</style>
